import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
// tslint:disable-next-line:no-submodule-imports
import es from "date-fns/locale/es";
// tslint:disable-next-line:no-submodule-imports
import it from "date-fns/locale/it";
// tslint:disable-next-line:no-submodule-imports
import en from "date-fns/locale/en-US";
import { tooltipate } from "../index";
registerLocale("es", es);
registerLocale("it", it);
registerLocale("en", en);
const never = {
    en: "never",
    es: "nunca",
    it: "mai",
};
export function getClosestTimeInterval(date, timeInterval, upper = true) {
    const minutes = date.getMinutes();
    const closest = (upper ? Math.ceil(minutes / timeInterval) : Math.floor(minutes / timeInterval)) * timeInterval;
    date.setMinutes(closest);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
export const KDate = ({ hint, hintVariant, tooltip, maxDate, minDate, readonly = false, date, required = false, noDateText, locale = "en", onChange, id, name, isClearable = false, dateFormat, useTime = false, timeInterval = 30, }) => {
    const [dateValue, setDateValue] = useState();
    const [firstTime, setFirstTime] = useState(true);
    function applyBoundaries(d) {
        if (d) {
            if (minDate && d.getTime() < minDate.getTime()) {
                return getClosestTimeInterval(new Date(minDate), timeInterval);
            }
            if (maxDate && d.getTime() > maxDate.getTime()) {
                return getClosestTimeInterval(new Date(maxDate), timeInterval, false);
            }
        }
        return d;
    }
    useEffect(() => {
        if (firstTime) {
            setFirstTime(false);
            setDateValue(applyBoundaries(date));
        }
    }, [date, firstTime]);
    const defDate = dateValue === null ? dateValue : dateValue || date;
    if (defDate && !useTime) {
        defDate.setHours(0, 0, 0);
    }
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => tooltipate(_jsxs("div", { className: `kdate-label ${readonly ? "readonly" : ""}`, onClick: readonly
            ? () => {
                /*noop*/
            }
            : onClick, children: [_jsxs("div", { children: [_jsx("i", { className: "fal fa-calendar" }), " ", value ? value : noDateText ? noDateText : never[locale]] }), _jsx("input", { type: "hidden", required: required, value: defDate ? defDate.toISOString() : "", id: id, name: name || id })] }), tooltip, undefined, true));
    return (_jsxs("div", { className: "text-left", children: [_jsx(ReactDatePicker, { selected: defDate, onChange: (edate) => {
                    let cdate = edate;
                    if (cdate && !useTime) {
                        cdate.setHours(0, 0, 0, 0);
                    }
                    cdate = applyBoundaries(cdate || undefined) || null;
                    setDateValue(cdate);
                    if (onChange) {
                        onChange(cdate || undefined);
                    }
                }, isClearable: isClearable, customInput: _jsx(ExampleCustomInput, {}), locale: locale, dateFormat: dateFormat || (useTime ? "Pp" : "P"), minDate: minDate, maxDate: maxDate, filterTime: (time) => {
                    if (minDate && minDate.getTime() > time.getTime()) {
                        return false;
                    }
                    if (maxDate && maxDate.getTime() < time.getTime()) {
                        return false;
                    }
                    return true;
                }, showTimeSelect: useTime, timeFormat: "p", timeIntervals: timeInterval }), hint ? _jsx("div", { className: `k-hint k-hint-variant-${hintVariant} text-left`, children: hint }) : null] }));
};
